import { Badge, Box, Text, Tooltip } from '@optiaxiom/react';
import { HoverCard, HoverCardContent, HoverCardTrigger } from '@optiaxiom/react/unstable';
import { IconScrewdriverWrench } from '@optimizely/axiom-icons';

import { CustomIcon } from '@frontend/components/ui';
import { Tool } from '@frontend/types';

import type { ToolsTableRow } from '../types';

const NameCell = ({ toolRow }: { toolRow: ToolsTableRow }) => {
  const rowData = toolRow;
  if (rowData.isRegistry) {
    return (
      <Box display="flex" alignItems="center" gap="8">
        <Text>{rowData.name}</Text>
        {!rowData.registry.organization_id && (
          <Tooltip content="Opal System tools">
            <Box>
              <CustomIcon name="optimizely" alt="Opal System Tools" height={12} />
            </Box>
          </Tooltip>
        )}
        <Badge variant="strong">{rowData.items.length}</Badge>
      </Box>
    );
  }

  return <ToolName tool={rowData.tool} />;
};

const ToolName = ({ tool }: { tool: Tool }) => {
  return (
    <HoverCard>
      <Box>
        <Box display="flex" alignItems="center" gap="8">
          <HoverCardTrigger asChild>
            <Text cursor="pointer">{tool.name}</Text>
          </HoverCardTrigger>
          {tool.is_system_function && (
            <Tooltip content="System tool">
              <Box>
                <CustomIcon name="optimizely" alt="Opal System Tool" height={12} />
              </Box>
            </Tooltip>
          )}
          {tool.is_preview && <Badge intent="information">Preview</Badge>}
        </Box>
        <HoverCardTrigger asChild>
          <Text fontSize="sm" color="fg.tertiary" lineClamp="1" cursor="pointer">
            {tool.description}
          </Text>
        </HoverCardTrigger>
      </Box>
      <HoverCardContent>
        <Box display="flex" flexDirection="column" gap="8" style={{ maxHeight: '320px' }}>
          <Box display="flex" gap="8" alignItems="start">
            <Box style={{ marginTop: '1px' }}>
              <IconScrewdriverWrench size={16} />
            </Box>
            <Text fontWeight="400">{tool.service.name}</Text>
            {!tool.service.organization_id && (
              <CustomIcon name="optimizely" alt="Opal System Tool" height={12} />
            )}
          </Box>
          <Text fontWeight="500" style={{ wordBreak: 'break-word' }}>
            {tool.name}
          </Text>
          <Box overflowY="auto">
            <Text fontSize="sm" color="fg.tertiary">
              {tool.description}
            </Text>
          </Box>
        </Box>
      </HoverCardContent>
    </HoverCard>
  );
};

export default NameCell;
